import React, { lazy } from 'react';
import { VerifiedFill } from '@datanomik/core-ui/icons';

const GovernanceHomePage = lazy(() =>
  import('./home/GovernanceHomePage').then((m) => ({ default: m.GovernanceHomePage })),
);

const PoliciesListPage = lazy(() =>
  import('./list/PoliciesListPage').then((m) => ({ default: m.PoliciesListPage })),
);

const PoliciesOverviewPage = lazy(() =>
  import('./overview/PoliciesOverviewPage').then((m) => ({ default: m.PoliciesOverviewPage })),
);

const InstitutionRatingsPage = lazy(() =>
  import('./ratings/InstitutionRatingsPage').then((m) => ({ default: m.InstitutionRatingsPage })),
);

const LiquidityProfilesPage = lazy(() =>
  import('./liquidity/LiquidityProfilesPage').then((m) => ({ default: m.LiquidityProfilesPage })),
);

const CompanyClassesPage = lazy(() =>
  import('./companies/CompanyClassesPage').then((m) => ({ default: m.CompanyClassesPage })),
);

export const GOVERNANCE_ROUTE_PATH = 'governance';
export const GOVERNANCE_POLICIES_SEGMENT = 'politicas';
export const GOVERNANCE_RATINGS_SEGMENT = 'ratings';
export const GOVERNANCE_COMPANIES_SEGMENT = 'empresas';
export const GOVERNANCE_LIQUIDITY_SEGMENT = 'liquidez';

export const getPoliciesRoutes = () => {
  const MODULE_LABEL = 'policies.module.label';
  const MODULE_DESCRIPTION = 'policies.module.description';

  return [
    {
      path: '',
      key: 'governance-home',
      label: MODULE_LABEL,
      description: MODULE_DESCRIPTION,
      element: <GovernanceHomePage />,
      icon: <VerifiedFill />,
    },
    {
      path: GOVERNANCE_POLICIES_SEGMENT,
      key: 'policies',
      label: MODULE_LABEL,
      description: MODULE_DESCRIPTION,
      element: <PoliciesListPage />,
      icon: <VerifiedFill />,
    },
    {
      path: GOVERNANCE_RATINGS_SEGMENT,
      key: 'policies-ratings',
      label: MODULE_LABEL,
      description: MODULE_DESCRIPTION,
      element: <InstitutionRatingsPage />,
      icon: <VerifiedFill />,
    },
    {
      path: GOVERNANCE_LIQUIDITY_SEGMENT,
      key: 'policies-liquidity',
      label: MODULE_LABEL,
      description: MODULE_DESCRIPTION,
      element: <LiquidityProfilesPage />,
      icon: <VerifiedFill />,
    },
    {
      path: GOVERNANCE_COMPANIES_SEGMENT,
      key: 'policies-companies',
      label: MODULE_LABEL,
      description: MODULE_DESCRIPTION,
      element: <CompanyClassesPage />,
      icon: <VerifiedFill />,
    },
    {
      path: `${GOVERNANCE_POLICIES_SEGMENT}/:policyId`,
      key: 'policies-detail',
      label: MODULE_LABEL,
      description: MODULE_DESCRIPTION,
      element: <PoliciesOverviewPage />,
      icon: <VerifiedFill />,
    },
  ];
};
